(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["klayd-clearance-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('klayd-clearance-popup');
    if (!dialog || dialog.dataset.initialized === 'true' || typeof dialog.showModal !== 'function') return;
    dialog.dataset.initialized = 'true';
    const continueButton = dialog.querySelector('[data-klayd-clearance-continue]');
    let pending = false;
    let pendingCheckout = null;
    let bypassForm = null;
    let previousDrawer = null;
    let suppressEscapeKeyup = false;
    let escapeTimer;
    let intentVersion = 0;
    let activeController = null;
    const cartRoot = form => form.closest('cart-drawer, [data-cart-page]');
    const termsAccepted = form => {
      const checkbox = form.querySelector('[data-cart-acceptance-checkbox]');
      return !checkbox || checkbox.checked;
    };
    const ready = (form, button) => {
      const drawer = form.closest('cart-drawer');
      return form.isConnected && button.isConnected && button.form === form && !button.matches(':disabled') && !cartRoot(form)?.classList.contains('is-loading') && (!drawer || drawer.classList.contains('is-open')) && termsAccepted(form);
    };
    const resume = ({ form, button }) => {
      if (!ready(form, button)) return;
      bypassForm = form;
      try {
        button.click();
      } finally {
        bypassForm = null;
      }
    };
    const restoreFocus = () => {
      const button = pendingCheckout?.button;
      if (previousDrawer) {
        if (previousDrawer.classList.contains('is-open')) window.theme?.a11y?.trapFocus?.(previousDrawer, { elementToFocus: button?.isConnected ? button : previousDrawer });
      } else if (button?.isConnected) {
        button.focus({ preventScroll: true });
      }
      previousDrawer = null;
    };
    const dismiss = () => {
      if (dialog.open) dialog.close();
      restoreFocus();
      pendingCheckout = null;
    };
    const invalidateIntent = () => {
      intentVersion += 1;
      activeController?.abort();
      if (dialog.open) dismiss();
    };
    ['theme:cart:add', 'theme:cart:update', 'theme:cart:change', 'theme:cart-drawer:close'].forEach(name => document.addEventListener(name, invalidateIntent, true));
    const status = async () => {
      const url = new URL(dialog.dataset.cartUrl, window.location.origin);
      url.searchParams.set('section_id', 'klayd-clearance-status');
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const controller = new AbortController();
      activeController = controller;
      const timer = window.setTimeout(() => controller.abort(), 5000);
      try {
        const response = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('Clearance status unavailable');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = parsed.querySelector('[data-klayd-clearance-status]');
        if (!data) throw new Error('Clearance status missing');
        const result = JSON.parse(data.textContent);
        if (typeof result.eligible !== 'boolean' || typeof result.itemCount !== 'number') throw new Error('Invalid clearance status');
        return result;
      } finally {
        window.clearTimeout(timer);
        if (activeController === controller) activeController = null;
      }
    };
    document.addEventListener('submit', async event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-cart-form]') || bypassForm === form) return;
      const button = event.submitter;
      if (!button || button.name !== 'checkout') return;
      if (!termsAccepted(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (pending || dialog.open || !ready(form, button)) return;
      pending = true;
      const requestVersion = ++intentVersion;
      const previousBusy = button.getAttribute('aria-busy');
      button.setAttribute('aria-busy', 'true');
      try {
        const result = await status();
        if (requestVersion !== intentVersion || !ready(form, button) || result.itemCount === 0) return;
        if (result.eligible) {
          pendingCheckout = { form, button };
          previousDrawer = form.closest('cart-drawer');
          if (previousDrawer) window.theme?.a11y?.removeTrapFocus?.();
          dialog.showModal();
        } else {
          resume({ form, button });
        }
      } catch (error) {
        if (requestVersion !== intentVersion) return;
        if (dialog.open) dismiss();
        else restoreFocus();
        pendingCheckout = null;
        resume({ form, button });
      } finally {
        pending = false;
        if (previousBusy === null) button.removeAttribute('aria-busy');
        else button.setAttribute('aria-busy', previousBusy);
      }
    }, true);
    dialog.querySelectorAll('[data-klayd-clearance-close]').forEach(button => button.addEventListener('click', dismiss));
    continueButton.addEventListener('click', () => {
      const checkout = pendingCheckout;
      dismiss();
      if (checkout) resume(checkout);
    });
    dialog.addEventListener('cancel', event => {
      event.preventDefault();
      event.stopPropagation();
      suppressEscapeKeyup = true;
      window.clearTimeout(escapeTimer);
      escapeTimer = window.setTimeout(() => { suppressEscapeKeyup = false; }, 1000);
      dismiss();
    });
    document.addEventListener('keyup', event => {
      if (suppressEscapeKeyup && event.key === 'Escape') {
        suppressEscapeKeyup = false;
        window.clearTimeout(escapeTimer);
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    dialog.addEventListener('click', event => {
      event.stopPropagation();
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klayd-purchase-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('klayd-purchase-guide')) {
    customElements.define('klayd-purchase-guide', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        this.content = this.closest('.product__content');
        if (!this.root || !this.content) return;
        this.choose = this.querySelector('[data-klayd-choose]');
        this.sticky = this.querySelector('[data-klayd-sticky]');
        this.stickyButton = this.querySelector('[data-klayd-sticky-button]');
        this.chosen = this.content.classList.contains('unload');
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        this.choose.addEventListener('click', () => this.focusSizes(), options);
        this.stickyButton.addEventListener('click', () => this.activate(), options);
        this.root.addEventListener('click', event => {
          const label = event.target.closest('.klayd-size-choice label');
          if (label || event.target.matches('[data-klayd-size-input]')) {
            this.chosen = true; this.content.classList.add('unload'); this.schedule();
          }
        }, {...options, capture:true});
        this.root.addEventListener('change', event => {
          if (event.target.matches('[data-klayd-size-input]')) {
            this.chosen = true;
            this.content.classList.add('unload');
            this.sync();
          }
        }, {...options, capture:true});
        this.root.addEventListener('submit', event => {
          if (event.target.matches('[data-product-form]') && this.needsChoice()) {
            event.preventDefault(); event.stopImmediatePropagation(); this.focusSizes();
          }
        }, {...options, capture:true});
        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) this.schedule();
        });
        this.observer.observe(this.content, {childList:true, subtree:true, attributes:true, attributeFilter:['disabled','aria-disabled']});
        window.addEventListener('scroll', () => this.visibility(), {...options, passive:true});
        window.addEventListener('resize', () => this.visibility(), options);
        this.sync();
      }
      disconnectedCallback() {
        this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame);
      }
      needsChoice() { return !!this.root.querySelector('[data-klayd-size-input]') && !this.chosen; }
      schedule() { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.sync()); }
      setText(element, text) { if (element && element.textContent !== text) element.textContent = text; }
      sync() {
        this.main = this.content.querySelector('[data-add-to-cart]');
        const needed = this.needsChoice();
        this.content.dataset.klaydChoice = needed ? 'needed' : 'chosen';
        this.choose.hidden = !needed;
        const selected = this.root.querySelector('[data-klayd-size-input]:checked');
        let variant;
        try { variant = JSON.parse(this.root.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch (_) {}
        this.soldOut = variant?.available === false;
        // The Shopify section response must match the radio before enabling a sticky purchase.
        const matched = !selected || variant?.options?.includes(selected.value);
        this.pending = !matched || (!this.soldOut && (!!this.main?.disabled || this.main?.getAttribute('aria-disabled') === 'true'));
        this.content.classList.toggle('klayd-has-restock', this.soldOut && !!this.content.querySelector('.restock-rocket-button'));
        this.stickyButton.disabled = !needed && this.pending;
        this.setText(this.stickyButton, needed ? this.dataset.choose : this.soldOut ? this.dataset.notify : this.dataset.add);
        this.setText(this.querySelector('[data-klayd-sticky-size]'), needed ? this.dataset.choose : selected?.value.split(' (')[0] || '');
        const price = this.content.querySelector('.price--on-sale .price-item--sale') || this.content.querySelector('.price__regular .price-item--regular') || this.content.querySelector('[data-product-price]');
        this.setText(this.querySelector('[data-klayd-sticky-price]'), price?.textContent.trim() || '');
        if (this.dataset.country === 'US' && this.dataset.currency === 'USD' && variant) {
          this.setText(this.querySelector('[data-klayd-shipping]'), variant.price >= 8500 ? this.dataset.free : this.dataset.shipping);
        }
        if (!needed && !this.soldOut && this.main && !this.main.disabled) {
          const text = this.main.querySelector('[data-add-to-cart-text]');
          if (text && this.main.dataset.preorder !== 'true') this.setText(text, this.dataset.add);
        }
        this.visibility();
      }
      focusSizes() {
        const sizes = this.root.querySelector('[data-klayd-size-buttons]');
        sizes?.scrollIntoView({behavior:'smooth',block:'center'});
        const input = sizes?.querySelector('input:checked') || sizes?.querySelector('input');
        input?.focus({preventScroll:true});
      }
      activate() {
        if (this.needsChoice()) return this.focusSizes();
        if (this.pending) return;
        if (this.soldOut) {
          const notify = [...this.content.querySelectorAll('button,a')].find(el => !this.contains(el) && /notify/i.test(el.textContent) && el.getBoundingClientRect().height > 0);
          if (notify) notify.click();
          else this.main?.scrollIntoView({behavior:'smooth',block:'center'});
          return;
        }
        this.main?.click();
      }
      visibility() {
        const target = this.needsChoice() ? this.choose : this.soldOut ? (this.content.querySelector('.restock-rocket-button') || this.main) : this.main;
        if (!target) return;
        this.sticky.hidden = target.getBoundingClientRect().bottom >= 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
